// Test IDs for the Copy.Click marketing site.
export const NAV = {
  logo: 'nav-logo',
  linkFollower: 'nav-link-follower',
  linkProvider: 'nav-link-provider',
  linkPricing: 'nav-link-pricing',
  linkBlog: 'nav-link-blog',
  linkFaq: 'nav-link-faq',
  linkGuides: 'nav-link-guides',
  linkContact: 'nav-link-contact',
  ctaTrial: 'nav-cta-trial',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  ctaTrial: 'hero-cta-trial',
  ctaHow: 'hero-cta-how',
  appStore: 'hero-badge-appstore',
  playStore: 'hero-badge-playstore',
};

export const PRICING = {
  toggle: 'pricing-billing-toggle',
  cardBasic: 'pricing-card-basic',
  cardPremium: 'pricing-card-premium',
  cardPro: 'pricing-card-pro',
  ctaBasic: 'pricing-cta-basic',
  ctaPremium: 'pricing-cta-premium',
  ctaPro: 'pricing-cta-pro',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-input-name',
  email: 'contact-input-email',
  topic: 'contact-select-topic',
  message: 'contact-textarea-message',
  submit: 'contact-submit',
};

export const FOOTER = {
  newsletterEmail: 'footer-newsletter-email',
  newsletterSubmit: 'footer-newsletter-submit',
};

export const COOKIE = {
  banner: 'cookie-banner',
  accept: 'cookie-accept',
  reject: 'cookie-reject',
};

export const FAQ = { section: 'faq-section' };
